import { FIELD_NAME } from '@constants';
import { useStore } from '@hooks';
import _ from 'lodash';
import { getEffectiveRestOfSiteCommission } from '../utils';

export const useCalculatePriority = () => {
    const store = useStore();
    const { calculatePriority: calculate, userExcludedIds, userIncludedIds } = store.campaignWizardStore;

    const calculatePriority = (formValues = {}, updateInDb = false, campaignId = null) => {
        const campaign = store.campaignWizardStore.campaign;
        const commission = store.accountsStore.currentAccount.commission;

        const storeValues = {
            [FIELD_NAME.CAMPAIGN.COMMISSION]: campaign?.commission,
            [FIELD_NAME.ACCOUNT.REST_OF_SITE_COMMISSION]: getEffectiveRestOfSiteCommission(commission),
            [FIELD_NAME.ACCOUNT.NEW_CUSTOMER_COMMISSION]: commission?.newCustomer,
            [FIELD_NAME.ACCOUNT.COLD_CUSTOMER_COMMISSION]: commission?.coldCustomer,
            [FIELD_NAME.CAMPAIGN.BOOST]: campaign?.boostId,
            userExcludedIds,
            userIncludedIds
        };

        const mergedValues = _.mergeWith({}, storeValues, formValues, (storeVal, formVal) =>
            formVal !== undefined ? formVal : storeVal
        );

        const calculateParams = {
            values: mergedValues,
            updateInDb
        };

        if (campaignId != null) {
            const id = Number(campaignId);
            if (!Number.isNaN(id)) {
                calculateParams.campaignId = id;
            }
        }

        return calculate(calculateParams);
    };

    return calculatePriority;
};
